/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import _t from 'i18n!nls/unified-description-page-common';

export const getAiSkillsModalContent = (s12nSlug?: string) => {
  if (s12nSlug === 'ai-essentials-google') {
    return (
      <>
        <p>{_t('Learn essential AI skills from Google experts ')}</p>
        <ul>
          <li>{_t('Accelerate daily tasks')}</li>
          <li>{_t('Brainstorm creative ideas')}</li>
          <li>{_t('Write clear prompts to get the results you want')}</li>
          <li>{_t('Identify and mitigate AI bias and risks')}</li>
          <li>{_t('Develop strategies to stay ahead of AI trends')}</li>
        </ul>
      </>
    );
  }
  if (s12nSlug === 'prompting-essentials-google') {
    return (
      <>
        <p>{_t('Learn how to write effective prompts using a 5-step framework:')}</p>
        <ul>
          <li>{_t('Draft emails and summarize long documents instantly')}</li>
          <li>{_t('Analyze data and fix spreadsheet formulas with AI')}</li>
          <li>{_t('Create AI agents to role-play conversations')}</li>
          <li>{_t('Simplify complex tasks using prompt chaining')}</li>
          <li>{_t('Build a library of reusable prompts for your work')}</li>
        </ul>
      </>
    );
  }
  if (s12nSlug === 'google-data-analytics') {
    return (
      <ul>
        <li>{_t('Boost your data analytics skills with AI')}</li>
        <li>{_t('Clean and prepare data with help from AI')}</li>
        <li>{_t('Organize data and build formulas using AI')}</li>
        <li>{_t('Use AI to help you ask more effective questions')}</li>
        <li>{_t('Create engaging data visualizations with AI')}</li>
        <li>{_t('Improve your R code with help from AI')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'google-digital-marketing-ecommerce') {
    return (
      <ul>
        <li>{_t('Boost your digital marketing skills with AI')}</li>
        <li>{_t('Use AI to help you understand your audience')}</li>
        <li>{_t('Kickstart marketing strategy ideas with AI')}</li>
        <li>{_t('Use AI to compare two campaign proposals')}</li>
        <li>{_t('Improve your email marketing using AI')}</li>
        <li>{_t('Brainstorm website copy ideas with AI')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'google-it-support') {
    return (
      <ul>
        <li>{_t('Boost your IT support skills with AI')}</li>
        <li>{_t('Leverage AI for faster troubleshooting')}</li>
        <li>{_t('Communicate technical concepts with AI')}</li>
        <li>{_t('Automate routine IT tasks with AI')}</li>
        <li>{_t('Simplify IT documentation using AI')}</li>
        <li>{_t('Use AI to identify IT security risks')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'google-project-management') {
    return (
      <ul>
        <li>{_t('Boost your project management skills with AI')}</li>
        <li>{_t('Use AI to create a project charter')}</li>
        <li>{_t('Identify potential project risks with gen AI')}</li>
        <li>{_t('Use AI to improve project communications')}</li>
        <li>{_t('Execute meetings more efficiently with AI')}</li>
        <li>{_t('Plan Sprint retrospectives using AI')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'google-ux-design') {
    return (
      <ul>
        <li>{_t('Boost your UX design skills with AI')}</li>
        <li>{_t('Generate personas with help from AI')}</li>
        <li>{_t('Use AI to help with design iteration')}</li>
        <li>{_t('Improve stakeholder communication with AI')}</li>
        <li>{_t('Simplify complex frameworks using AI')}</li>
        <li>{_t('Use AI to help write your portfolio copy')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'google-cybersecurity') {
    return (
      <ul>
        <li>{_t('Boost your cybersecurity skills with AI')}</li>
        <li>{_t('Decode complex security frameworks with AI')}</li>
        <li>{_t('Use AI to help identify bugs')}</li>
        <li>{_t('Refine code with help from AI')}</li>
        <li>{_t('Understand system vulnerabilities with AI')}</li>
        <li>{_t('Prioritize alerts with AI')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'ibm-data-analyst') {
    return (
      <ul>
        <li>{_t('Generate & augment data using AI')}</li>
        <li>{_t('Prepare data using AI')}</li>
        <li>{_t('Query databases using AI')}</li>
        <li>{_t('Gain data insights using AI')}</li>
        <li>{_t('Visualize data using AI')}</li>
        <li>{_t('Create dashboards using AI')}</li>
        <li>{_t('Use tools like ChatGPT, ChatCSV, Mostly.AI, SQLthroughAI, & Copilot')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'ibm-cybersecurity-analyst') {
    return (
      <ul>
        <li>{_t('Detect phishing, malware & NLP attacks using AI')}</li>
        <li>{_t('Block prompt injection & malicious code using AI')}</li>
        <li>{_t('Boost vulnerability management & threat hunting using AI')}</li>
        <li>{_t('Improve incident response & forensics using AI')}</li>
        <li>{_t('Support threat prediction & detection using AI')}</li>
        <li>{_t('Develop prompts using tools like ChatGPT')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'ibm-data-engineer' || s12nSlug === 'ibm-relational-database-administrator') {
    return (
      <ul>
        <li>{_t('Design data architectures using AI')}</li>
        <li>{_t('Automate schema design using AI')}</li>
        <li>{_t('Generate, augment & anonymize data using AI')}</li>
        <li>{_t('Build pipelines & ETL workflows using AI')}</li>
        <li>{_t('Query databases & analyze data using AI')}</li>
        <li>{_t('Maintain databases & repositories using AI')}</li>
        <li>{_t('Set up & manage infrastructure using AI')}</li>
        <li>{_t('Use tools like ChatGPT, Mostly.AI, & Copilot')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'ibm-data-science') {
    return (
      <ul>
        <li>{_t('Generate & augment datasets using AI')}</li>
        <li>{_t('Prepare & query data using AI')}</li>
        <li>{_t('Extract data insights using AI')}</li>
        <li>{_t('Visualize data using AI')}</li>
        <li>{_t('Develop & refine ML models using AI')}</li>
        <li>{_t('Use tools like ChatGPT, ChatCSV & Tomat.ai')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'ibm-digital-marketing-and-growth-hacking') {
    return (
      <ul>
        <li>{_t('Create ad copy, images & video using AI')}</li>
        <li>{_t('Optimize SEO with keywords & content using AI')}</li>
        <li>{_t('Personalize email campaigns & messaging using AI')}</li>
        <li>{_t('Craft social media posts & product descriptions using AI')}</li>
        <li>{_t('Refine digital ads & e-commerce strategies using AI')}</li>
        <li>{_t('Apply A/B testing & automation using AI')}</li>
        <li>{_t('Use tools like ChatGPT & Gemini')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'ibm-full-stack-cloud-developer') {
    return (
      <ul>
        <li>{_t('Generate code snippets, scripts & programs using AI')}</li>
        <li>{_t('Design applications, architecture & prototypes using AI')}</li>
        <li>{_t('Detect bugs, refactor code & optimize performance using AI')}</li>
        <li>{_t('Automate testing, documentation & translation using AI')}</li>
        <li>{_t('Integrate GenAI into DevSecOps & CI/CD workflows using AI')}</li>
        <li>{_t('Strengthen security using AI')}</li>
        <li>{_t('Use tools like ChatGPT, GitHub Copilot, Gemini, & IBM watsonx Code Assistant')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'ibm-ios-android-mobile-app-developer-pc') {
    return (
      <ul>
        <li>{_t('Design mobile apps using AI')}</li>
        <li>{_t('Create content for apps with AI')}</li>
        <li>{_t('Transform gaming and AR/VR apps using AI')}</li>
        <li>{_t('Personalize marketing and support with AI')}</li>
        <li>{_t('Enhance apps with embedded and cloud-based AI')}</li>
        <li>{_t('Use tools such as Uizard, Apple Intelligence, Project IDX, & Claude AI')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'java-developer') {
    return (
      <ul>
        <li>{_t('Set up a Java environment for AI development')}</li>
        <li>{_t('Build AI application features & neural networks with AI')}</li>
        <li>{_t('Apply NLP, image recognition, & classification using AI')}</li>
        <li>{_t('Design and integrate AI service layers & APIs with AI')}</li>
        <li>{_t('Use tools such as Deeplearning4j & Spring AI')}</li>
        <li>{_t('Test, debug, deploy, & manage Spring AI applications')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'ibm-program-manager') {
    return (
      <ul>
        <li>{_t('Enhance program planning, delivery & closure using AI')}</li>
        <li>{_t('Support stakeholder engagement & governance using AI')}</li>
        <li>{_t('Analyze data & visualize program insights using AI')}</li>
        <li>{_t('Identify risks & optimize decision-making using AI')}</li>
        <li>{_t('Drive benefits realization & value delivery using AI')}</li>
        <li>{_t('Apply ethical AI practices in program management')}</li>
        <li>{_t('Use ChatGPT, Copilot & other AI tools')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'ibm-product-owner') {
    return (
      <ul>
        <li>{_t('Strengthen product strategy & roadmap planning with AI')}</li>
        <li>{_t('Generate user stories, refine backlogs, & prioritize features using AI')}</li>
        <li>{_t('Analyze market trends, customer feedback, & sentiment with AI')}</li>
        <li>{_t('Improve stakeholder engagement & communication using AI')}</li>
        <li>{_t('Optimize tasks, sprint execution, & value delivery using AI')}</li>
        <li>{_t('Use tools such as ChatGPT, Google Gemini, & Copilot')}</li>
      </ul>
    );
  }

  return null;
};

export default getAiSkillsModalContent;
